export default __webpack_public_path__ + "static/media/arrow.99c40c52.svg";